export default __webpack_public_path__ + "static/media/26.2547e022.pdf";